// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1mb_V","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3LVrh","obliqueLine":"membershipbadge_obliqueLine__2QHsh"};